import { TOKEN } from "../../actions/login/";

export default function(state = null, action){
  switch (action.type) {
    case TOKEN:
    return { token: action.payload };
    default:
  }

  return state;
}
